import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { selectCompetitorsSobState } from 'partner360/features/competitorsSob/selectors/selectCompetitorsSobState'
import {
  applySobCompetitorsComment,
  IApplySobCompetitorsCommentResponse,
} from 'partner360/services/competitorsSob/applySobCompetitorsComment'

import { REQUEST_APPLY_COMPETITORS_SOB_COMMENT } from '../constants'

export interface IRequestApplySobCompetitorChangesParameters {
  fYear: number
  partnerId: string
  programType: ProgramTypes
}

export const requestApplySobCompetitorsComment = createAsyncThunk<
  IApplySobCompetitorsCommentResponse,
  IRequestApplySobCompetitorChangesParameters
>(REQUEST_APPLY_COMPETITORS_SOB_COMMENT, (params, { getState }) => {
  const state = getState()
  const competitorsState = selectCompetitorsSobState(state)
  const comment = competitorsState.comment[params.programType] || ''
  return applySobCompetitorsComment({ ...params, comment })
})
